module.exports = __webpack_public_path__ + "img/实德集团.1544af4a.png";